// import external dependencies
import $ from "jquery";

import "scrollmagic/scrollmagic/uncompressed/plugins/jquery.ScrollMagic";
import "scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators";
import "jquery-colorbox";
import imagesLoaded from "imagesloaded";

imagesLoaded.makeJQueryPlugin($);

// Import everything from autoload
import "./autoload/_bootstrap.js";

// import local dependencies
import Router from "./util/Router";
import common from "./routes/common";
import home from "./routes/home";
import aboutUs from "./routes/about";
import singleScuole from "./routes/single";
import taxonomyData from "./routes/taxonomyData";

/** Populate Router instance with DOM routes */
const routes = new Router({
    // All pages
    common,
    // Home page
    home,
    // About Us page, note the change from about-us to aboutUs.
    aboutUs,
    // Single post
    singleScuole,
    // Category Archive
    taxonomyData,
});

// Load Events
$(document).ready(() => routes.loadEvents());
$(window).on("load", () => routes.loadLateEvents());


// WEBPACK FOOTER //
// ./scripts/main.js